<template>
  <div class="sme-input">
    <input
      ref="input"
      :type="type"
      :value="value"
      :placeholder="placeholder"
      :autocomplete="autocomplete"
      :disabled="disabled"
      @keyup.enter="handleEnter"
      @keyup="handleKeyup"
      @keypress="handleKeypress"
      @keydown="handleKeydown"
      @focus="handleFocus"
      @blur="handleBlur"
      @input="handleInput"
      @change="handleChange"
    >
  </div>
</template>

<script>
export default {
  name: 'sme-input',
  props: {
    type: {
      type: String,
      default: 'text'
    },
    value: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: '请输入内容'
    },
    autocomplete: {
      type: String,
      default: 'off'
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    handleEnter (event) {
      this.$emit('enter', event)
    },
    handleKeydown (event) {
      this.$emit('keydown', event)
    },
    handleKeypress (event) {
      this.$emit('keypress', event)
    },
    handleKeyup (event) {
      this.$emit('keyup', event)
    },
    handleIconClick (event) {
      this.$emit('click', event)
    },
    handleFocus (event) {
      this.$emit('focus', event)
    },
    handleBlur (event) {
      this.$emit('blur', event)
    },
    handleInput (event) {
      const value = event.target.value
      this.$emit('input', value)
    },
    handleChange (event) {
      this.$emit('change', event)
    }
  }
}
</script>

<style lang="scss">
$primary-color: #39f;

.sme-input {
  display: inline-block;
  width: 245px;
  line-height: normal;
  vertical-align: middle;

  input {
    width: 100%;
    height: 25px;
    line-height: 24px;
    padding: 0px 8px;
    border: 1px solid #ccc;
    border-radius: 2px;
    color: #333;
    font-size: 12px;
    outline: none;
    box-sizing: border-box;

    &:focus {
      border-color: $primary-color;
    }
  }
}
</style>
